module.exports = __webpack_public_path__ + "img/icon-not-summary.f146df3.svg";